import css from "styled-jsx/css";

export default css`
  .width-100 {
    width: 100%;
  }
  .products {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  .product {
    height: 65px;
    border-radius: 8px;
    margin-bottom: 1rem;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: start;
  }

  @media (min-width: 768px) {
    .menu {
      width: 60%;
    }
  }
`;
